import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="blog-not-found">Post not found.</div>;
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24" data-testid="blog-loading">Loading...</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 py-16" data-testid="blog-detail-page">
      <Link to="/blog" className="inline-flex items-center gap-2 text-dim hover:text-[#FF3B30] text-xs uppercase tracking-widest" data-testid="back-to-blog">
        <ArrowLeft size={14} /> Back to Blog
      </Link>
      <div className="section-eyebrow mt-6">{post.author}</div>
      <h1 className="font-display text-4xl sm:text-6xl uppercase mt-3 leading-[0.95]">{post.title}</h1>
      <div className="mt-8 scu-card overflow-hidden">
        <img src={post.cover_image} alt={post.title} className="w-full h-[420px] object-cover" />
      </div>
      <div className="mt-8 text-lg leading-relaxed text-white/85 whitespace-pre-wrap">{post.body}</div>
      <div className="mt-6 flex flex-wrap gap-2">
        {post.tags?.map((t) => (
          <span key={t} className="text-[10px] uppercase tracking-widest border border-white/15 px-2 py-1">{t}</span>
        ))}
      </div>
    </article>
  );
}
